import React, { useContext, useEffect, useState } from "react";
import style from "../style/TempLogin.module.scss";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { AuthContext } from "../contexts/AuthContext";
import { useMutation, useQuery, useQueryClient } from "react-query";
import CountDown from "../components/CountDown";
import apiClient from "../libraries/ApiClient";
import { v4 as uuidv4 } from "uuid";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "transparent",
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-error": {
        borderColor: "#EB4D3D",
      },
    },
  })
);
const CssButton = styled(Button)({
  fontSize: 16,
  background: "#057AFF",
  "&:disabled": {
    border: "1px solid #818181",
    color: "#818181",
    background: "#E0E0E0",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

function TempLogin() {
  const codeRule = /^-?\d*\.?\d*$/;
  const navigate = useNavigate();
  const queryClint = useQueryClient();

  // const { mailValue } = useContext(LoginContext);
  const { myAuth, setMyAuth } = useContext(AuthContext);
  const { AccountRowId } = myAuth;
  // console.log(AccountRowId);
  // console.log(Account);

  const [code, setCode] = useState("");
  const [vaild, setVaild] = useState(false);

  const [timeLeft, setTimeLeft] = useState(180); // 180 seconds = 3 minutes
  const [isRunning, setIsRunning] = useState(true);

  const onChangeCodeValue = (e) => {
    const value = e.target.value;
    const vaildateValue = (value) => codeRule.test(value);
    // console.log(vaildateValue(value));
    // console.log(value);
    let a = value.split("");

    if (vaildateValue(value) && a.length <= 4) {
      setCode(e.target.value);
    }
    if (a.length === 4) {
      setVaild(true);
    }
  };

  const sendMailData = async ({ queryKey }) => {
    const [_, AccountRowId] = queryKey;
    // console.log(Account);
    // console.log(AccountRowId);
    const data = {
      Data: {
        AccountMasterRowId: AccountRowId,
      },
    };

    const res = await apiClient.postAes(
      "api/otp/Send/TempAccount/Security",
      data
    );

    console.log(res);
    if (res.data?.Code == 0) {
      return res;
    } else if (res.data?.Code == 1) {
      alert(res.data?.Message);
      navigate("/Login");
    } else if (res.data?.Code == 2) {
      alert(res.data?.Message);      
      //call 臨時登入api取得資訊
      getLoginData({ AccountRowId });
    }
  };

  const loginData = async ({ AccountRowId }) => {
    const data = {
      Data: {
        AccountMasterRowId: AccountRowId,
      },
    };
    console.log(data, "loginData");
    const res = await apiClient.postAes("api/Login/TempAccount/security", data);

    return res?.data;
  };

  const sendMailAgainData = async ({ AccountRowId }) => {
    const data = {
      Data: {
        AccountMasterRowId: AccountRowId,
      },
    };

    const res = await apiClient.postAes(
      "api/otp/Send/TempAccount/Security",
      data
    );
    return res?.data?.Code;
  };

  const sendCodeData = async ({ AccountRowId, code }) => {
    const data = {
      Data: {
        AccountMasterRowId: AccountRowId,
        OtpCode: code,
      },
    };
    //api位置需調整
    const res = await apiClient.postAes(
      "api/otp/Validate/TempAccount/Security",
      data
    );
    console.log(res, "sendCodeData");
    return res?.data;
  };

  const { data, isLoading } = useQuery(
    ["sendMailData", AccountRowId],
    sendMailData
  );

  const { data: loginResData, mutate: getLoginData } = useMutation(loginData);

  useEffect(() => {
    if (+loginResData?.Code === 0) {
      console.log(loginResData);
      if (loginResData?.Data === null) {
        alert(loginResData?.Message);
      } else {
        const LocalstorageData = {
          authorized: true,
          AccountRowId: loginResData?.Data?.AccountRowId,
          Name: loginResData?.Data?.Name,
          Account: loginResData?.Data?.Account,
          AccountPhone: loginResData?.Data?.AccountPhone,
          Token: loginResData?.Data?.Token,
          Menu: loginResData?.Data?.Menus,
          SelfIdentities:
            loginResData?.Data?.Identities?.landseed_zonedefense_tbc,
          OtherIdentities:
            loginResData?.Data?.Identities?.other_zonedefense_tbc,
          Hospital: loginResData?.Data?.OrganizationName,
          HospitalCode: loginResData?.Data?.OrganizationCode,
          IsAdmin: loginResData?.Data?.IsAdmin,
          IsTempAccount: loginResData?.Data?.IsTempAccount,
          AccountPermission: loginResData?.Data?.AccountPermission,
          // IsOtherHospital: IsOtherHospitalAccount,
        };
        // console.log(LocalstorageData);
        localStorage.setItem("auth", JSON.stringify(LocalstorageData));
        const actionUuid = uuidv4();
        localStorage.setItem("actionUuid", actionUuid);
        setMyAuth({ ...LocalstorageData, authorized: true });
        alert("成功登入");
        navigate("/ReferralDataList");
      }
    } else if (+loginResData?.Code === 1) {
      alert(loginResData?.Message);
    }
  }, [loginResData]);

  // const { data: codeResData, mutate } = useMutation(sendCodeData);
  const { data: codeResData, mutate } = useMutation(sendCodeData);
  //console.log(codeResData);

  useEffect(() => {
    if (+codeResData?.Code === 0) {
      //console.log(codeResData);
      if (codeResData?.Data === null) {
        alert(codeResData?.Message);
      } else {
        //call 臨時登入api取得資訊
        getLoginData({ AccountRowId });
      }
    } else if (+codeResData?.Code === 1) {
      alert(codeResData?.Message);
    }
  }, [codeResData]);

  const { data: mailAgainData, mutate: sendAgainMutate } =
    useMutation(sendMailAgainData);

  useEffect(() => {
    if (+mailAgainData === 0) {
      alert("已重新發送");
    }
  }, [mailAgainData]);

  return (
    <div className={style.TempLogin_body}>
      <div className={style.TempLogin_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.TempLogin_form_body}>
        <div className={style.logo}>
          <img src="./end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.TempLogin_form}>
          <div className={style.TempLogin_form_top}>
            <div className={style.TempLogin_title}>登入區域聯防轉診平台</div>
            <div className={style.TempLogin_little_title}>
              系統已將驗證碼寄到您輸入的手機/信箱，請在下方輸入您收到的驗證碼
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入驗證碼(4碼數字)"
                variant="filled"
                onChange={onChangeCodeValue}
                value={code}
                // error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
            </div>
            <div className={style.btn}>
              <CssButton
                variant="contained"
                onClick={() => {
                  mutate({ AccountRowId, code });
                }}
                disabled={!vaild}
              >
                登入
              </CssButton>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                }}
              >
                您還沒收到驗證碼嗎?
                {timeLeft === 0 && (
                  <div
                    style={{
                      textDecoration: "none",
                      color: "#057AFF",
                      textAlign: "center",
                      padding: "16px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      sendAgainMutate({ AccountRowId });
                      setIsRunning(true);
                      setTimeLeft(180);
                    }}
                  >
                    再次發送驗證碼
                  </div>
                )}
                <CountDown
                  setTimeLeft={setTimeLeft}
                  setIsRunning={setIsRunning}
                  isRunning={isRunning}
                  timeLeft={timeLeft}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TempLogin;
